import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService, TableState } from '../_DWM-Generic-Services/generic-service.service';
import * as CommonFunctions from 'src/app/shared/commen-function-file';
import { Config } from 'src/app/app-constant';
import { TimeOnlyPipePipe } from 'src/app/shared/pipe/time-only-pipe.pipe';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { DwmattachmentpopupComponent } from '../My-DWM/dwmattachmentpopup/dwmattachmentpopup.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { DwmaudittrailComponent } from '../DWM-Audit-Trail/dwmaudittrail/dwmaudittrail.component';

type selectedFilters = {
  selectedEmpId?: null;
  selectedYear?: null;
  selectedDate?: null;
  searchString?: null;
  selectedGrade?: null;
  selectedDepartment?: null;
};
@Component({
  selector: 'app-employeee-dwm',
  templateUrl: './employeee-dwm.component.html',
  styleUrls: ['./employeee-dwm.component.scss']
})
export class EmployeeeDwmComponent implements OnInit {
  selectedFilters: any = {
    selectedEmpId: null,
    selectedYear: null,
    selectedMonth: null,
    selectedDate: null,
    selectedDwmType: 'Monthly',
    searchString: null,
    selectedGrade: null,
    selectedDepartment: null
  };
  selectedTaskList: any = [];

  commonFunctions = CommonFunctions;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  monthsList: string[] = [];
  isAllSelected = false;
  today: Date = new Date();
  disableDelete = false;

  tableState!: TableState<any>;
  listOfYears: any = [];

  checkDwmStatus = this.dwmGenericServiceService?.checkDwmStatus || [];
  checkDwmCriticality = this.dwmGenericServiceService?.checkDwmCriticality || [];
  statusLabelAndValue = this.dwmGenericServiceService?.statusLabelAndValue || [];

  // dwmManagerUser: any = null;
  userIsAdminTypes: any = null;
  dwmAdminData: any;
  dwmUsers: any = null;
  dwmSkippDay: { applSkipRejectOrAccept: any; isSkipped: boolean; isSkippedText: string; userName: string; empComment: string; date: string; data: any } = {
    applSkipRejectOrAccept: null,
    isSkipped: false,
    isSkippedText: '',
    userName: '',
    empComment: '',
    date: '',
    data: []
  };
  checkIfIsRNDOrL4AndAboveEmployee: any = null;
  dwmUserTaskList: any = [];
  teamTableHeaders: { required: boolean; label: string; key: string }[] = [];

  dwmCategories: any = null;
  formatedataVariable = CommonFunctions.formatText;
  cuttoffDetails: { getCurrentCuttOffDate: Date | null; getCurrentCuttOffDateInMs: number | null } | null = {
    getCurrentCuttOffDate: null,
    getCurrentCuttOffDateInMs: null
  };

  getAllDwmTypes: any = [];
  isExitedSelectedDate: any = null;
  getMonthalyFrequency: any = this.dwmGenericServiceService.getFrequency('Monthly') || [];
  getMonthalyFrequencyForL4AndAbove: any = this.dwmGenericServiceService.getFrequency('Monthly', true) || [];
  getAnuallyFrequency: any = this.dwmGenericServiceService.getFrequency('Annually') || [];
  getAllFrequency: any = this.dwmGenericServiceService.getFrequencyAll('Monthly') || [];
  loggedInUserRole: any;
  selectedTaskId: number | null = null;
  multiDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  constructor(
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private datePipe: DatePipe,
    private timeOnlyPipePipe: TimeOnlyPipePipe,
    public dwmGenericServiceService: DwmGenericServiceService,
    public getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.dwmGenericServiceService.getDWMSetup().subscribe((res: any) => {
      this.cuttoffDetails = this.dwmGenericServiceService.checkGetDWMSetup(res);
    });

    this.loggedInUserCompanyID = this.getCompanyAndUsersData.loggedInUserCompanyID;
    this.loggedInUserId = this.getCompanyAndUsersData.loggedInUserId;

    this.loggedInUserRole = this.getCompanyAndUsersData.loggedInUserRole;
    this.monthsList = this.genericService.allMonth;
    this.selectedFilters.selectedYear = this.selectedYear();
    this.listOfYears = this.getCompanyAndUsersData.getAllFinancialYears;
    this.selectedFilters.selectedDate = this.genericService.getTodaysDate;
    this.selectedFilters.selectedMonth = this.dwmGenericServiceService.getCurrentMonthByDate(this.selectedFilters.selectedDate);

    this.getProductsData();

    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            // console.log(this.dwmAdminData);
            this.getDepartments();
            this.generateData();
          }
        }
      });
    } else {
      this.getDepartments();
      this.generateData();
    }
  }

  departmentsList: any = [];
  getDepartments() {
    this.httpService.callGetService(`${this.config.getDwmDepartmentsByCompany}/${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      this.departmentsList = res?.data || [];
      if (this.userIsAdminTypes?.userIsAdmin) this.departmentsList = this.departmentsList.filter((department: any) => this.dwmAdminData?.department.includes(department));
    });
  }

  gradesList: any = [];
  getGrades(selectedDepartment: any) {
    this.selectedFilters.selectedEmpId = null;
    this.employeesList = [];
    if (selectedDepartment?.length) {
      this.httpService
        .callPostService(this.config.getDwmGradesByDepartment, {
          companyId: this.loggedInUserCompanyID,
          department: selectedDepartment
        })
        .subscribe((res: any) => {
          this.selectedFilters.selectedGrade = null;
          this.gradesList = res?.data || [];
          if (this.userIsAdminTypes?.userIsAdmin) this.gradesList = this.gradesList.filter((gradesList: any) => this.dwmAdminData?.band.includes(gradesList));
        });
    } else {
      this.selectedFilters.selectedGrade = null;
      this.gradesList = [];
    }
  }

  employeesList: any = [];
  onGradeChange(selectedGrade: string) {
    // console.log('out of emp list 1- - - - ');
    if (!this.selectedFilters?.selectedDepartment || !this.selectedFilters?.selectedGrade) return;
    this.selectedFilters.selectedEmpId = null;
    this.employeesList = [];
    // console.log('out of emp list 2- - - - ');

    if (!selectedGrade?.length) return;
    // console.log('out of emp list 3- - - - ');

    const payload = {
      companyId: this.loggedInUserCompanyID,
      department: this.selectedFilters?.selectedDepartment,
      grades: selectedGrade
    };

    this.httpService.callPostService(this.config.getDwmUserListByGrade, payload).subscribe((res: any) => {
      const empList = res?.data || [];
      // console.log('out of emp list - - - - ');
      if (this.userIsAdminTypes?.userIsAdmin) {
        // console.log('in emp list - - - - ');
        this.employeesList = empList.filter((emp: any) => this.dwmAdminData.employeeDetails.some((empAdmin: any) => +emp.id === +empAdmin.employeeId));
        // console.log('this.employeesList - - - - ', this.employeesList);
      } else {
        this.employeesList = empList || [];
      }
    });
  }

  selectedYear() {
    return this.getCompanyAndUsersData.convertFinancialYear(this.getCompanyAndUsersData?.loggedInCompanyFiscalyear || '', 'yearTextToNumber', '_');
  }

  generateData() {
    this.dwmUserTaskList = [];
    this.tableState = this.dwmGenericServiceService.init([], this.pageSize);
    this.resetAllSelectedTasks();
    this.dwmSkippDay = {
      applSkipRejectOrAccept: null,
      isSkipped: false,
      isSkippedText: '',
      data: [],
      empComment: '',
      userName: '',
      date: ''
    };

    const getStartAndEdnDate = this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate);
    this.selectedFilters.selectedMonth = this.dwmGenericServiceService.getCurrentMonthByDate(this.selectedFilters.selectedDate);
    this.checkIfIsRNDOrL4AndAboveEmployee = this.getCompanyAndUsersData.checkIfIsRNDOrL4AndAboveEmployee(this.selectedFilters?.selectedEmpId);
    this.getAllDwmTypes = this.dwmGenericServiceService.getDwmType(this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove);

    this.isExitedSelectedDate = this.dwmGenericServiceService.checkIfIsExitedSelectedDate(this.selectedFilters.selectedDate);

    // const request = {
    //   companyId: this.loggedInUserCompanyID,
    //   userId: this.loggedInUserId,
    //   from: getStartAndEdnDate,
    //   to: getStartAndEdnDate,
    //   date: null,
    //   toYear: null,
    //   fromYear: null,
    //   userType: null,
    //   yearRange: null
    // };

    this.getAchievementPercentageTotalWorkHours(this.selectedFilters?.selectedEmpId);
    // console.log('asdfas adsadf asd getStartAndEdnDate', getStartAndEdnDate);
    // this.selectedFilters.isCutoffTaskEditable = this.dwmGenericServiceService.isCreateTaskEnabled(getStartAndEdnDate, this.cuttoffDetails?.getCurrentCuttOffDate);

    forkJoin({
      dwmTransactionData: this.httpService.callGetService(`${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}&userId=${this.selectedFilters?.selectedEmpId || ''}&dwmEventDate` + `=${getStartAndEdnDate}`),
      // dwmMasterData: this.httpService.callGetService(`${this.config.getDwmMaster}?companyId=${this.loggedInUserCompanyID}`),
      getCategoriesList: this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`),
      dwmSkipDayData: this.httpService.callGetService(`${this.config.getSkipDay}?companyId=${this.loggedInUserCompanyID}`)
    }).subscribe({
      next: (data: any) => {
        // console.log('data?.getAdminMembers - -- - ', this.dwmAdminData);
        // console.log('data?.dwmTransactionData - -- - ', data?.dwmTransactionData);
        // console.log('data?.dwmMasterData - -- - ', data?.dwmMasterData);
        // console.log('data?.getCategoriesList - -- - ', data?.getCategoriesList);
        // console.log('data?.getCategoriesList - -- - ', this.teamTableHeaders);
        // console.log('data?.dwmSkipDayData - -- - ', data?.dwmSkipDayData);
        if (this.checkIfIsRNDOrL4AndAboveEmployee?.isRnd) {
          this.teamTableHeaders = [
            { required: true, label: 'Category', key: 'categoryName' },
            { required: this.checkIfIsRNDOrL4AndAboveEmployee?.isRnd || false, label: 'Product No', key: 'productNo' },
            { required: this.checkIfIsRNDOrL4AndAboveEmployee?.isRnd || false, label: 'Plant', key: 'plant' },
            { required: true, label: 'Actionable', key: 'actionable' },
            { required: this.checkIfIsRNDOrL4AndAboveEmployee?.isRnd ? true : false, label: 'Duration', key: 'duration' },
            { required: !this.checkIfIsRNDOrL4AndAboveEmployee?.isL4AndAbove ? true : false, label: 'Time From', key: 'timeFrom' },
            { required: !this.checkIfIsRNDOrL4AndAboveEmployee?.isL4AndAbove ? true : false, label: 'Time To', key: 'timeTo' },
            { required: false, label: 'Repeat', key: 'isRepetativeTask' },
            { required: true, label: 'Frequency', key: 'dwmFrequency' },
            { required: false, label: 'Status', key: 'dwmStatus' },
            { required: false, label: 'Employee Comment', key: 'employeeComment' },
            { required: false, label: 'Manager Comment', key: 'managerComment' },
            { required: false, label: 'Attachment', key: 'attachment' },
            { required: false, label: 'Audit Trail', key: 'auditTrail' }
          ];
        } else {
          this.teamTableHeaders = [
            { required: true, label: 'Category', key: 'categoryName' },
            { required: true, label: 'Actionable', key: 'actionable' },
            { required: !this.checkIfIsRNDOrL4AndAboveEmployee?.isL4AndAbove ? true : false, label: 'Time From', key: 'timeFrom' },
            { required: !this.checkIfIsRNDOrL4AndAboveEmployee?.isL4AndAbove ? true : false, label: 'Time To', key: 'timeTo' },
            { required: false, label: 'Repeat', key: 'isRepetativeTask' },
            { required: true, label: 'Frequency', key: 'dwmFrequency' },
            { required: false, label: 'Status', key: 'dwmStatus' },
            { required: false, label: 'Employee Comment', key: 'employeeComment' },
            { required: false, label: 'Manager Comment', key: 'managerComment' },
            { required: false, label: 'Attachment', key: 'attachment' },
            { required: false, label: 'Audit Trail', key: 'auditTrail' }
          ];
        }

        this.dwmUsers = data?.dwmTransactionData?.status ? this.dwmGenericServiceService.sortByIdDesc(data?.dwmTransactionData?.data) : [];
        this.dwmCategories = data?.getCategoriesList?.status ? data?.getCategoriesList?.data.map((item: any) => ({ ...item, categoryName: item.categoryName?.trim() })).filter((item: any) => (this.checkIfIsRNDOrL4AndAboveEmployee.isRnd ? true : item.categoryName !== 'R&D')) : [];

        // collect all team user IDs
        const teamUserIds = this.employeesList.map((user: any) => +user.id);
        // const { selectedStatus, selectedCriticality } = this.selectedFilters;
        const filteredDwmUsersData = this.dwmUsers.filter((item: any) => teamUserIds.includes(+item.userId));
        // .filter((item: any) => {
        //   const hasStatusFilter = selectedStatus !== null && selectedStatus !== undefined;
        //   const hasCriticalityFilter = selectedCriticality !== null && selectedCriticality !== undefined;
        //   const statusMatch = hasStatusFilter ? item?.dwmStatus === selectedStatus : true;
        //   const criticalityMatch = hasCriticalityFilter ? item?.isCriticalTask == (selectedCriticality === 'Critical') : true;
        //   return statusMatch && criticalityMatch;
        // });

        // console.log('filteredDwmUsersData - -- - ', this.employeesList, this.dwmUsers, teamUserIds, filteredDwmUsersData);
        // console.log('filteredDwmUsersData - -- - ', teamUserIds, filteredDwmUsersData);

        filteredDwmUsersData.forEach((filteredDwmData: any) => {
          const getDataAsPerMonthAndYear = this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate) == this.getCompanyAndUsersData.getDateInMs(filteredDwmData?.dwmEventDate);

          if (filteredDwmData?.userId == this.selectedFilters.selectedEmpId && getDataAsPerMonthAndYear) {
            // Skip Day
            if (data?.dwmSkipDayData?.status) {
              for (const skipData of data?.dwmSkipDayData?.data) {
                const matchDate = this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate) == this.getCompanyAndUsersData.getDateInMs(skipData.dwmDate);
                if (matchDate && +skipData.userId == +filteredDwmData?.userId) {
                  const userName = this.employeesList.find((user: any) => +user.id == +skipData.userId);
                  skipData.managerId = this.loggedInUserId;

                  this.dwmSkippDay.applSkipRejectOrAccept = skipData?.isSkipped !== null;
                  this.dwmSkippDay.isSkipped = true;
                  this.dwmSkippDay.isSkippedText = skipData.isSkipped ? '<span class="clr-green">The Day is Skipped</span>' : skipData.isSkipped == null ? '<span class="clr-blue">Applied for Skip Day</span>' : '<span class="clr-red">Skip Day Rejected</span>';
                  this.dwmSkippDay.userName = userName.firstName + ' ' + userName.lastName;
                  this.dwmSkippDay.empComment = skipData.reason;
                  this.dwmSkippDay.date = skipData.dwmDate;
                  this.dwmSkippDay.data.push(skipData);

                  break;
                }
              }
            }

            const attachments = filteredDwmData.dwmDoc ? filteredDwmData.dwmDoc.split(',') : [];
            // Table Data
            this.dwmUserTaskList.push({
              checkboxCheck: false,

              id: filteredDwmData?.id || '',
              companyId: filteredDwmData?.companyId || '',
              userId: filteredDwmData?.userId || '',
              managerId: filteredDwmData?.managerId || '',
              attachments: attachments,
              hasSavedAttachments: attachments.length > 0,

              dwmMasterId: filteredDwmData?.dwmMasterId || '',
              categoryId: filteredDwmData?.categoryId || '',
              productId: filteredDwmData?.productId || '',
              actionable: filteredDwmData?.actionable || '',
              plantLocation: filteredDwmData?.plantLocation || '',
              dwmEventDate: filteredDwmData?.dwmEventDate || '',
              dwmDuration: filteredDwmData?.dwmDuration || '',
              timeFrom: filteredDwmData?.timeFrom || '',
              timeTo: filteredDwmData?.timeTo || '',
              empComments: filteredDwmData?.empComments || '',
              managerComments: filteredDwmData?.managerComments || '',
              dwmDoc: filteredDwmData?.dwmDoc || '',
              isCriticalTask: filteredDwmData?.isCriticalTask || '',
              dwmStatus: filteredDwmData?.dwmStatus,

              dwmFrequency: filteredDwmData?.dwmFrequency?.toUpperCase()?.replace('_', '-') || '',
              isRepetativeTask: filteredDwmData?.isRepetativeTask || '',
              categoryName: this.dwmCategories.find((cat: any) => cat.categoryId === filteredDwmData?.categoryId)?.categoryName.trim() || '',
              dwmStatusIsCompleted: filteredDwmData?.dwmStatus == 'Completed' || false,
              checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
              checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
              _prevComment: filteredDwmData?.managerComments
            });
          }
        });

        // console.log('this.dwmUserTaskList - - - - -   ', this.dwmUserTaskList);
        // Initialize table
        this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
      }
    });
  }

  applyDataFilters(event: any, filterName: any, applyFilter: boolean = true) {
    this.dwmSkippDay = {
      applSkipRejectOrAccept: null,
      isSkipped: false,
      isSkippedText: '',
      userName: '',
      empComment: '',
      date: '',
      data: []
    };
    // console.log(event, filterName, applyFilter);
    setTimeout(() => {
      if (!applyFilter) {
        //   this.selectedFilters[filterName] = event;
        // } else {
        this.selectedFilters = {
          selectedEmpId: null,
          selectedYear: this.selectedYear(),
          selectedDate: this.genericService.getTodaysDate,
          searchString: null,
          selectedDepartment: null,
          selectedGrade: null,
          selectedCriticality: null
        };
        this.dwmUserTaskList = [];
        this.tableState = this.dwmGenericServiceService.init([], this.pageSize);
        this.resetAllSelectedTasks();
      }

      // if (filterName == 'selectedYear' || filterName == 'selectedDate') this.selectedFilters.selectedDepartment = null;
      if (!this.selectedFilters?.selectedDepartment || filterName == 'selectedDepartment') this.getGrades(this.selectedFilters?.selectedDepartment);
      if (filterName == 'selectedGrade') this.onGradeChange(this.selectedFilters?.selectedGrade);
      if (filterName == 'selectedEmpId' || filterName == 'selectedYear' || filterName == 'selectedDate') this.generateData();

      // console.log('this.selectedFilters - - - ', this.selectedFilters);
      // this.generateData();
      this.isAllSelected = false;
    }, 250);
  }

  selectALLDwms(event: any, paginatedData: any) {
    this.disableDelete = false;
    this.selectedTaskList = [];
    paginatedData.forEach((record: any) => (record.checkboxCheck = false));
    if (event?.checked) {
      paginatedData.forEach((record: any, index: number) => {
        if (record?.isNew || record?.dwmStatus == 'Completed') this.disableDelete = true;
        record.checkboxCheck = true;
        this.selectedTaskList.push({ index, item: record });
      });
    }

    this.isAllSelected = event?.checked ?? false;
  }

  selectSingleDwm(event: any, item: any, index: number) {
    this.disableDelete = false;
    if (event?.checked) {
      if (item?.isNew) this.disableDelete = true;
      if (!this.selectedTaskList.some((t: any) => t.item.id === item.id)) this.selectedTaskList.push({ index, item });
    } else {
      this.selectedTaskList = this.selectedTaskList.filter((task: any) => task.item.id !== item.id);
    }
    if (this.selectedTaskList?.length) {
      this.selectedTaskList.map((data: any) => {
        if (data.item?.isNew || data.item.dwmStatus == 'Completed') this.disableDelete = true;
      });
    }
    this.isAllSelected = this.paginatedData?.length > 0 && this.paginatedData.every(r => r.checkboxCheck);
  }

  downloadReport(downloadType: string) {
    const source = this.tableState?.filteredData || [];

    if (!source?.length) {
      this.toastr.warning('No task data to export!');
      return;
    }

    if (downloadType === 'excel') {
      const data = source.map(task => {
        return {
          Category: task?.categoryName || '',
          'Product Id': task?.productId || '',
          'Plant Location': task?.plantLocation || '',
          Actionable: task?.actionable || '',
          'Dwm Duration': task?.dwmDuration || '',
          'Time From': task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '',
          'Time To': task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '',
          Repeat: task?.isRepetativeTask || '',
          Frequency: task?.dwmFrequency || '',
          Status: task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '',
          'Emp Comments': task?.empComments || '',
          'Manager Comments': task?.managerComments || '',
          Attachment: task?.dwmDoc || ''
        };
      });
      this.dwmGenericServiceService.saveAsExcelFile(data, 'Review Team DWM', 'review_team_dwm');
    }

    if (downloadType === 'pdf') {
      let pdfTableHeaders: string[] = [];
      this.teamTableHeaders.map((header: any) => {
        if (header?.key != 'auditTrail') pdfTableHeaders.push(header.label);
      });
      const data = source.map(task => {
        return [task?.categoryName || '', task?.productId || '', task?.plantLocation || '', task?.actionable || '', task?.dwmDuration || '', task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '', task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '', task?.isRepetativeTask || '', task?.dwmFrequency || '', task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '', task?.empComments || '', task?.managerComments || '', task?.dwmDoc || ''];
      });
      this.dwmGenericServiceService.downloadTableAsPdf(pdfTableHeaders, data, 'Review Team DWM', 'review_team_dwm');
    }
  }

  resetAllSelectedTasks() {
    this.selectedTaskList = [];
    this.isAllSelected = false;
  }
  /* ------------------------- Filers ------------------------- */
  onSearch(event: Event | null) {
    const value = (event?.target as HTMLInputElement)?.value || '';
    this.tableState = this.dwmGenericServiceService.applyFilter(this.tableState, value);
    this.resetAllSelectedTasks();
  }
  onSort(column: string) {
    this.tableState = this.dwmGenericServiceService.sort(this.tableState, column);
  }
  changePage(page: number) {
    this.tableState = this.dwmGenericServiceService.changePage(this.tableState, page);
    this.resetAllSelectedTasks();
  }
  changePageSize(size: number): void {
    this.tableState = this.dwmGenericServiceService.changePageSize(this.tableState, size);
    this.resetAllSelectedTasks();
  }

  get paginatedData() {
    if (!this.tableState) return [];
    return this.dwmGenericServiceService.paginate(this.tableState);
  }

  get totalEntries() {
    return this.dwmGenericServiceService.totalEntries(this.tableState);
  }

  get totalPages() {
    return this.dwmGenericServiceService.totalPages(this.tableState);
  }

  get startEntry() {
    return this.dwmGenericServiceService.startEntry(this.tableState);
  }

  get endEntry() {
    return this.dwmGenericServiceService.endEntry(this.tableState);
  }

  get currentPage(): number {
    return this.tableState?.currentPage ?? 1;
  }

  get pageSize(): number {
    return this.tableState?.pageSize ?? 25;
  }
  /* ------------------------- End Filers ------------------------- */

  /* ------------------------- Table Data actions ------------------------- */
  checkMaxLength(data: any) {
    this.dwmGenericServiceService.checkMaxLength(data);
  }

  // Update Status and Manager comment
  changeStatus(item: any, status: string): void {
    if (item.dwmStatus === status || this.dwmSkippDay?.empComment === 'Accept skip day' || !this.userIsAdminTypes?.userIsAdmin) return;
    this.saveUpdateDWM(item, status);
  }

  // On Download or upload attachment
  onAttachmentDownload(item: any) {
    this.dialog.open(DwmattachmentpopupComponent, {
      data: { attachments: item.dwmDoc.split(',') },
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mx-h60vh']
    });
  }

  // Remove Newly Created task
  removeTask(paginatedData: any, index: any) {
    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to discard the changes?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          paginatedData.splice(index, 1);
          this.dwmUserTaskList = paginatedData;
          this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
        }
      });
  }

  // Upload or download document
  uploadDWMAttachments(event: any, item: any): void {
    const files: FileList = event.target.files;

    if (!files || files.length === 0) return;

    // -------- File size validation (10MB) --------
    for (let i = 0; i < files.length; i++) {
      const sizeInMB = files[i].size / (1024 * 1024);
      if (sizeInMB > 10) {
        this.toastr.error('File size should not exceed 10MB');
        return;
      }
    }

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
      formData.append('fileType', files[i].type.split('/')[0]);
    }

    this.loader.simpleLoader();

    const url = this.config.uploadFileLocallymultipleForPMS;

    this.httpService.submitFormService(url, formData).subscribe({
      next: (res: any) => {
        this.loader.dismissLoader();

        /**
         * EXPECTED RESPONSE:
         * res.data = ['path1', 'path2']
         */
        const uploadedPaths = res?.data || [];

        // merge with existing attachments
        item.attachments = [...(item.attachments || []), ...uploadedPaths];

        item.hasSavedAttachments = item.attachments.length > 0;
        // console.log('Uplaodedd..........', item.hasSavedAttachments);
        //  Non R&D → auto save
        if (item.categoryName !== 'R&D-Project' || item.categoryName !== 'R&D') {
          this.saveUpdateDWM(item, '');
        }
      },
      error: () => {
        this.loader.dismissLoader();
        this.toastr.error('Attachment upload failed');
      }
    });
  }

  removeSavedAttachments(item: any): void {
    item.attachments = [];
    item.dwmDoc = null;
    item.hasSavedAttachments = false;

    this.saveUpdateDWM(item, '');
  }

  // For R&D task when select Product No Product
  productList: any = [];
  getProductsData() {
    this.httpService.callGetService(`${this.config.getProducts}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      // console.log('Products Data :', res);
      this.productList = (res?.data || []).map((p: any) => ({
        ...p,
        productNumber: p.productNo
      }));
    });
  }

  // For R&D Task on select product no set plant
  onProductChange(item: any): void {
    if (item?.isNew) {
      if (!(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')) {
        item.productNumber = item.productId = item.dwmDuration = null;
        item.plantLocation = '';
        return;
      } else {
        item.timeFrom = item.timeTo = item.dwmFrequency = null;
      }
    }

    const selectedProduct = this.productList.find((p: any) => p.productId === item.productId);

    if (!selectedProduct) {
      item.productNumber = null;
      item.plantLocation = '';
      return;
    }

    item.productNumber = selectedProduct.productNumber;
    item.plantLocation = selectedProduct.plantLocation;
  }

  // For R&D Task on Duration
  maxDurationError = false;
  onDurationInput(item: any, event?: Event) {
    // ---------------- BLOCK INVALID KEYS ----------------
    if (event && event.type === 'keydown') {
      const keyboardEvent = event as KeyboardEvent;

      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

      if (allowedKeys.includes(keyboardEvent.key)) {
        return;
      }

      // Block everything except numbers
      if (!/^\d$/.test(keyboardEvent.key)) {
        keyboardEvent.preventDefault();
        return;
      }
    }

    let value = item.dwmDuration || '';
    this.maxDurationError = false;
    //  Remove everything except digits
    value = value.replace(/\D/g, '');

    //  Insert colon after hours
    if (value.length > 2) {
      value = value.slice(0, value.length - 2) + ':' + value.slice(-2);
    }

    let [hours, minutes] = value.split(':');

    // Limit hours length
    if (hours && hours.length > 2) {
      hours = hours.slice(0, 2);
    }

    // Convert to numbers for validation
    const h = Number(hours);
    const m = minutes ? Number(minutes) : 0;

    // ---------- VALIDATION : MAX 24:00 ----------
    if (h > 24 || (h === 24 && m > 0)) {
      this.maxDurationError = true;

      // Stop further input
      if (event && event.type === 'keydown') {
        (event as KeyboardEvent).preventDefault();
      }
      return;
    }

    // Minutes validation
    if (minutes) {
      minutes = minutes.slice(0, 2);
      if (+minutes > 59) minutes = '59';
    }

    item.dwmDuration = minutes !== undefined ? `${hours}:${minutes}` : hours;
  }

  onDurationBlur(item: any) {
    if (!item.dwmDuration) return;

    let [hours, minutes] = item.dwmDuration.split(':');

    // Auto pad minutes
    if (minutes && minutes.length === 1) {
      minutes = '0' + minutes;
    }

    // Auto pad hours
    if (hours && hours.length === 1) {
      hours = '0' + hours;
    }

    item.dwmDuration = minutes ? `${hours}:${minutes}` : hours;
  }

  auditpopup(taskId: number | null) {
    this.dialog.open(DwmaudittrailComponent, {
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {
        taskId: taskId // Pass the task ID to the audit component
      }
    });
  }
  /* ------------------------- End Of Table Data actions  ------------------------- */

  /* ------------------------- Button Actions ------------------------- */
  achievementTotalHrs: any;
  getAchievementPercentageTotalWorkHours(userId: any) {
    this.achievementTotalHrs = null;
    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getCompanyAndUsersData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedFilters?.selectedYear, this.dwmGenericServiceService.getMonthName(this.selectedFilters?.selectedDate)),
      month: this.selectedFilters.selectedMonth,
      userId: userId
    };

    this.httpService.callPostService(this.config.dwmAdminAchievementPercentageTotalWorkHours, payload).subscribe({
      next: (data: any) => {
        if (data.status) {
          this.achievementTotalHrs = data.data;
        }
      }
    });
  }

  onClickDeleteRecord() {
    // console.log('this.selectedTaskList - - - - - ', this.selectedTaskList, this.dwmAdminData);
    if (!this.selectedTaskList?.length) return;

    const selectedUserName = this.dwmAdminData.employeeDetails.find((user: any) => +user.employeeId == +this.selectedFilters.selectedEmpId);
    const selectedDate = this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate);

    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to delete selected tasks for ${selectedUserName.firstName + ' ' + selectedUserName.lastName} on ${selectedDate}? This action cannot be undone.` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          const payload = {
            companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
            ids: this.selectedTaskList.map((data: any) => data.item.id)
          };

          this.httpService.callPostService(this.config.updateDeleteTasks, payload).subscribe({
            next: (data: any) => {
              if (data?.status) {
                this.toastr.success(data?.message);
                this.generateData();
              } else {
                this.toastr.error('Deletion failed');
              }
            },
            error: () => {
              this.toastr.error('Deletion failed');
            }
          });
        }
      });
  }

  // onClickDeleteRecord(paginatedData: any): void {
  //   if (!this.selectedTaskList?.length) return;

  //   const grouped = this.selectedTaskList.reduce(
  //     (acc: any, obj: any) => {
  //       obj?.item?.isNew ? acc.new.push(obj.item) : acc.previous.push(obj.item);
  //       return acc;
  //     },
  //     { new: [], previous: [] }
  //   );

  //   const { new: newRecords, previous: previousRecords } = grouped;

  //   if (newRecords.length) {
  //     const newIds = new Set(newRecords.map((r: any) => r.id));

  //     paginatedData.filter((task: any) => !(task?.isNew && newIds.has(task?.id)));

  //     this.dwmUserTaskList = paginatedData;
  //     this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
  //   }

  //   if (!previousRecords.length) return;

  //   const selectedUser = this.dwmAdminData.employeeDetails.find((user: any) => +user.employeeId === +this.selectedFilters.selectedEmpId);

  //   const selectedDate = this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate);

  //   this.allPopupModalExecutionServiceService
  //     .confirmationPopupComponentExe({ msg: `Are you sure you want to delete selected tasks for ${selectedUser?.firstName + ' ' + selectedUser?.lastName} on ${selectedDate}? This action cannot be undone.` })
  //     .afterClosed()
  //     .subscribe((confirmed: boolean) => {
  //       if (!confirmed) return;

  //       const payload = {
  //         companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
  //         ids: previousRecords.map((r: any) => r.id)
  //       };
  //     });
  // }

  /* ------------------------- Ende of Button Actions ------------------------- */

  addNewTask(paginatedData: any) {
    // console.log(paginatedData, paginatedData);
    // console.log('add new task ', this.selectedFilters);
    paginatedData.unshift({
      id: this.dwmGenericServiceService.generateUniqueIdByExistingList(paginatedData),
      isNew: true,
      checkboxCheck: false,
      userId: this.selectedFilters.selectedEmpId,
      managerId: +this.loggedInUserId,
      companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
      dwmYear: this.getCompanyAndUsersData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedFilters?.selectedYear, this.dwmGenericServiceService.getMonthName(this.selectedFilters?.selectedDate)),
      fiscalYear: this.getCompanyAndUsersData?.loggedInCompanyFiscalyear,
      empComments: null,

      // dwmType: this.selectedFilters.selectedDwmType,
      dwmFrequency: null,
      isRepetativeTask: true,

      dwmMonth: null,
      categoryId: null,
      dwmDate: null,
      timeFrom: '',
      timeTo: '',
      actionable: null,
      isCriticalTask: null,
      dwmStatus: 'Pending',
      managerComments: null,

      categoryName: null,
      checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
      checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
      isRequiredCategory: false,
      isRequiredActionable: false,
      isRequiredFrequency: false,
      isRequiredTimeFrom: false,
      isRequiredTimeTo: false,
      isRequiredProductId: false,
      isRequiredDwmDuration: false,
      isRequiredDwmDate: false,
      isCutoffTaskEditable: true
    });

    this.selectedTaskList = [];
    this.isAllSelected = false;
    this.dwmUserTaskList = paginatedData;
    this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
  }

  saveAllRecords(saveData: any) {
    const groupedData = saveData.reduce(
      (acc: any, item: any) => {
        const isNew = item?.isNew === true;
        const category = item?.categoryName?.trim()?.toLowerCase();

        if (isNew) {
          if (category === 'r&d') {
            acc.newRnd.push(item);
          } else {
            acc.newOther.push(item);
          }
        } else {
          if (category === 'r&d') {
            acc.existingRnd.push(item);
          } else {
            acc.existingOther.push(item);
          }
        }

        return acc;
      },
      {
        newRnd: [],
        newOther: [],
        existingRnd: [],
        existingOther: []
      }
    );

    if (!(groupedData?.existingOther?.length || groupedData?.existingRnd?.length || groupedData?.newOther?.length || groupedData?.newRnd?.length)) {
      this.toastr.warning('No records found to save');
      return;
    }
    // console.log(groupedData);
    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to save/update all records?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          // this.onAddNewOrUpdateNonRndTasksApi(items);
          if (groupedData?.existingOther?.length) {
          } else if (groupedData?.existingRnd?.length) {
          } else if (groupedData?.newOther?.length) {
            this.onAddNewOrUpdateNonRndTasksApi(groupedData.newOther);
          } else if (groupedData?.newRnd?.length) {
          }
        }
      });
  }

  payloadForNewOther(items: any) {}
  payloadForNewRnd(items: any) {}
  payloadForExistingOther(items: any) {}
  payloadForExistingRnd(items: any) {}

  onSaveNewDwm(items: any, paginatedData?: any, index?: any) {
    const tasksToSave = items.filter((t: any) => t.categoryName === 'R&D');
    if (tasksToSave?.length) {
      this.allPopupModalExecutionServiceService
        .confirmationPopupComponentExe({ msg: `Are you sure you want to save R&D Task?` })
        .afterClosed()
        .subscribe((confirmed: any) => {
          if (confirmed) {
            this.saveOrUpdateRNDTask(items, paginatedData, index);
          }
        });
    } else if (items?.length) {
      this.allPopupModalExecutionServiceService
        .confirmationPopupComponentExe({ msg: `Are you sure you want to save these changes?` })
        .afterClosed()
        .subscribe((confirmed: any) => {
          if (confirmed) {
            this.onAddNewOrUpdateNonRndTasksApi(items, paginatedData, index);
          }
        });
    }
  }

  // saveOrUpdateRNDTask(item: any): void {
  //   const payload = item.map((task: any) => {
  //     const normalizeDuration = (val: string | null): string | null => {
  //       if (!val) return null;

  //       // If only hours (e.g. "22")
  //       if (/^\d{1,2}$/.test(val)) {
  //         return val.padStart(2, '0') + ':00';
  //       }

  //       // If HH:m → HH:0m
  //       if (/^\d{1,2}:\d{1}$/.test(val)) {
  //         const [h, m] = val.split(':');
  //         return h.padStart(2, '0') + ':' + m.padStart(2, '0');
  //       }

  //       // Already valid HH:mm
  //       return val;
  //     };

  //     const categoryId = this.dwmCategories.find((cat: any) => cat.categoryName === task?.categoryName)?.categoryId ?? null;
  //     task.isRequiredCategory = !categoryId;
  //     task.isRequiredActionable = !task?.actionable;
  //     if (task?.categoryName == 'R&D-Project' || task?.categoryName == 'R&D') {
  //       task.isRequiredProductId = !task?.productId;
  //       task.isRequiredDwmDuration = !task?.dwmDuration;
  //       if (task?.isRequiredProductId || task?.isRequiredDwmDuration) return null;
  //     } else {
  //       task.isRequiredFrequency = task?.isRepetativeTask ? (task?.dwmFrequency ? false : true) : false;
  //       if (!task?.checkIfIsL4AndAboveEmployee) {
  //         task.isRequiredTimeFrom = !task?.timeFrom;
  //         task.isRequiredTimeTo = !task?.timeTo;
  //         if (task?.isRequiredTimeFrom || task?.isRequiredTimeTo) return null;
  //       }
  //     }
  //     // console.log(task.isRepetativeTask, task.isRequiredCategory, task.isRequiredActionable, task.isRequiredDwmDate, task.isRequiredTimeFrom, task.isRequiredTimeTo, task?.isRequiredFrequency, task?.dwmFrequency);
  //     if (task?.isRequiredCategory || task?.isRequiredActionable || task?.isRequiredFrequency) return null;

  //     return {
  //       id: null,
  //       companyId: task?.companyId,
  //       userId: Number(task?.userId),
  //       managerId: +task?.managerId,
  //       categoryId: categoryId, // R&D
  //       plantLocation: task?.plantLocation ?? null,
  //       productId: task?.productId ?? null,
  //       actionable: task?.actionable || null,
  //       dwmEventDate: this.selectedFilters?.selectedDate ? this.dwmGenericServiceService.formatDate(this.selectedFilters?.selectedDate) : null,
  //       dwmDuration: normalizeDuration(task?.dwmDuration),
  //       empComments: task?.empComments ?? null,
  //       dwmStatus: 'Not_Started',
  //       dwmDoc: task?.attachments?.join(',') || null,
  //       isCriticalTask: false
  //     };
  //   });

  //   console.log('payload -- - - - - ', payload);

  //   this.httpService.callPostService(this.config.saveRNDEmployee, payload).subscribe({
  //     next: (res: any) => {
  //       this.toastr.success('Saved Successfully');

  //       this.generateData();
  //     },
  //     error: (err: any) => {
  //       const errorMsg = err?.error?.message || 'Save failed';
  //       this.toastr.warning(errorMsg, 'Warning');
  //     }
  //   });
  // }

  // saveNewTaskPayload(item: any) {
  //   const categoryId = this.dwmCategories.find((cat: any) => cat.categoryName === item?.categoryName)?.categoryId ?? null;

  //   // console.log(item?.isRepetativeTask, item?.dwmFrequency);
  //   item.isRequiredCategory = !categoryId;
  //   item.isRequiredActionable = !item?.actionable;
  //   if (item?.categoryName == 'R&D-Project' || item?.categoryName == 'R&D') {
  //     item.isRequiredProductId = !item?.productId;
  //     item.isRequiredDwmDuration = !item?.dwmDuration;
  //     if (item?.isRequiredProductId || item?.isRequiredDwmDuration) return null;
  //   } else {
  //     item.isRequiredFrequency = item?.isRepetativeTask ? (item?.dwmFrequency ? false : true) : false;
  //     if (!item?.checkIfIsL4AndAboveEmployee) {
  //       item.isRequiredTimeFrom = !item?.timeFrom;
  //       item.isRequiredTimeTo = !item?.timeTo;
  //       if (item?.isRequiredTimeFrom || item?.isRequiredTimeTo) return null;
  //     }
  //   }
  //   // console.log(item.isRepetativeTask, item.isRequiredCategory, item.isRequiredActionable, item.isRequiredDwmDate, item.isRequiredTimeFrom, item.isRequiredTimeTo, item?.isRequiredFrequency, item?.dwmFrequency);
  //   if (item?.isRequiredCategory || item?.isRequiredActionable || item?.isRequiredFrequency) return null;

  //   return {
  //     dwmType: item?.dwmType,
  //     dwmFrequency: item?.isRepetativeTask ? (Array.isArray(item?.dwmFrequency) ? null : item?.dwmFrequency) : null,
  //     userId: Number(item?.userId),
  //     managerId: +item?.managerId,
  //     companyId: item?.companyId,
  //     categoryId: categoryId,
  //     dwmYear: +item?.dwmYear,
  //     fiscalYear: item?.fiscalYear,
  //     dwmMonth: this.genericService.getCurrentMonthInNumber(this.selectedFilters.selectedMonth),
  //     dwmDate: this.selectedFilters?.selectedDate ? this.dwmGenericServiceService.formatDate(this.selectedFilters?.selectedDate) : null,
  //     timeFrom: item?.timeFrom || '',
  //     timeTo: item?.timeTo || '',
  //     actionable: item?.actionable || null,
  //     isRepetativeTask: item?.isRepetativeTask,
  //     isCriticalTask: item?.isCriticalTask ?? false,
  //     dwmStatus: item?.dwmStatus || null,

  //     managerComments: item?.managerComments || null,
  //     empComments: item?.empComments || null,
  //     dwmDoc: item?.attachments?.join(',') || null
  //   };
  // }

  saveUpdateDWM(item: any, status: string): void {
    // console.log('saveUpdateDWM - - - - ', item);
    if (item.isNew) return;

    if (item.categoryName == 'R&D') {
      if (status) item.dwmStatus = status;
      this.saveOrUpdateRNDTask([item]);
    } else {
      const getStatus = status || item.dwmStatus;
      const payload = [
        {
          managerComments: item?.managerComments || null,
          empComments: item?.empComments || null,
          dwmStatus: getStatus == 'Done_with_delay' ? 'Completed' : getStatus,
          dwmDoc: item.attachments?.join(',') || null,

          id: item?.id || null,
          dwmMasterId: item?.dwmMasterId || null,
          companyId: item?.companyId || null,
          categoryId: this.dwmCategories.find((cat: any) => cat.categoryName === item?.categoryName)?.categoryId ?? null,
          actionable: item?.actionable || null,
          timeFrom: item?.timeFrom || null,
          timeTo: item?.timeTo || null,
          dwmFrequency: item?.dwmFrequency || null,
          dwmMonth: item?.dwmMonth || null,
          dwmDate: item?.dwmEventDate || null,
          managerId: item?.managerId || null,
          isCriticalTask: item?.isCriticalTask || null
        }
      ];

      this.httpService.callPostService(this.config.updateDWM, payload).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.toastr.success(item.id ? 'Updated successfully' : 'Saved successfully');
            if (status) {
              item.dwmStatus = status;
              item.isEdit = false;
            }
          }
        },
        error: () => {
          this.toastr.error('Save failed');
        }
      });
    }
  }

  /* -------------------------  new Functions optimized ------------------------- */

  private normalizeDuration(val: string | null): string | null {
    if (!val) return null;

    if (/^\d{1,2}$/.test(val)) {
      return val.padStart(2, '0') + ':00';
    }

    if (/^\d{1,2}:\d{1}$/.test(val)) {
      const [h, m] = val.split(':');
      return h.padStart(2, '0') + ':' + m.padStart(2, '0');
    }

    return val;
  }

  private getCategoryId(categoryName: string | undefined): number | null {
    return this.dwmCategories.find((cat: any) => cat.categoryName === categoryName?.trim())?.categoryId ?? null;
  }

  private isRndCategory(categoryName: string): boolean {
    return ['R&D', 'R&D-Project'].includes(categoryName?.trim());
  }

  private validateTask(task: any, categoryId: number | null): boolean {
    task.isRequiredCategory = !categoryId;
    task.isRequiredActionable = !task?.actionable;

    if (this.isRndCategory(task?.categoryName)) {
      task.isRequiredProductId = !task?.productId;
      task.isRequiredDwmDuration = !task?.dwmDuration;

      return !(task.isRequiredCategory || task.isRequiredActionable || task.isRequiredProductId || task.isRequiredDwmDuration);
    }

    task.isRequiredFrequency = task?.isRepetativeTask ? !task?.dwmFrequency : false;

    if (!task?.checkIfIsL4AndAboveEmployee) {
      task.isRequiredTimeFrom = task?.dwmFrequency === 'HOURLY' && !task?.timeFrom;
      task.isRequiredTimeTo = task?.dwmFrequency === 'HOURLY' && !task?.timeTo;

      if (task.isRequiredTimeFrom || task.isRequiredTimeTo) {
        return false;
      }
    }

    return !(task.isRequiredCategory || task.isRequiredActionable || task.isRequiredFrequency);
  }

  private verifyAndReturnPayload(items: any): any {
    // console.log(items);
    if (!items?.length) return [];

    const payload: any = [];
    let hasError = false;

    for (const item of items) {
      const result = item.categoryName == 'R&D' ? this.saveOrUpdateRNDTaskPayload(item) : this.saveNewTaskPayload(item);

      if (!result) {
        hasError = true;
        continue; // don't push null
      }

      payload.push(result);
    }

    if (hasError) {
      if (!this.toastr.toasts.some((t: any) => t.toastType === 'error')) {
        this.toastr.error('Please fill the mandatory fields');
      }
      return [];
    }

    return payload;
  }

  // verifyNewOrExistingTask(items: any): any {
  //   // console.log('saveNewTaskPaydload - - - - ', items);
  //   // return this.verifyAndReturnPayload(items, this.saveNewTaskPayload(items));
  //   return this.verifyAndReturnPayload(items);
  // }

  // verifyRndTask(items: any): any {
  //   // return this.verifyAndReturnPayload(items, this.saveOrUpdateRNDTaskPayload(items));
  //   return this.verifyAndReturnPayload(items);
  // }

  private saveOrUpdateRNDTaskPayload(task: any): any {
    // console.log('rnd - - - - - - ', task);
    // clear payload for RND
    // return items.map((task: any) => {
    const categoryId = this.getCategoryId(task?.categoryName);

    if (!this.validateTask(task, categoryId)) return null;

    return {
      id: task?.isNew ? null : (task?.id ?? null), // supports update also
      dwmStatus: task?.isNew ? 'Not_Started' : task?.dwmStatus == 'Done_with_delay' ? 'Completed' : task?.dwmStatus || 'Not_Started',
      companyId: task?.companyId,
      userId: Number(task?.userId),
      managerId: task?.isNew ? null : task?.managerId || null,
      categoryId,
      plantLocation: task?.plantLocation ?? null,
      productId: task?.productId ?? null,
      actionable: task?.actionable || null,
      dwmEventDate: this.selectedFilters?.selectedDate ? this.dwmGenericServiceService.formatDate(this.selectedFilters?.selectedDate) : null,
      dwmDuration: this.normalizeDuration(task?.dwmDuration),
      empComments: task?.empComments ?? null,
      dwmDoc: task?.attachments ? task?.attachments?.join(',') : null,
      isCriticalTask: task?.isCriticalTask ?? false,
      managerComments: task?.managerComments || ''
    };
    // }).filter((item: any): item is any => item !== null);
  }

  private saveNewTaskPayload(item: any) {
    // console.log('saveNedwTaskPayload ---- - - - -  ', item);
    // return item
    //   .map((item: any) => {
    const categoryId = this.getCategoryId(item?.categoryName);

    if (!this.validateTask(item, categoryId)) return null;

    return {
      id: item?.isNew ? null : item?.id || null,
      dwmType: item?.isNew ? this.selectedFilters.selectedDwmType : item?.dwmType,
      dwmActive: item?.isNew ? true : item?.dwmActive || null,
      dwmFrequency: item?.isRepetativeTask && !Array.isArray(item?.dwmFrequency) ? item?.dwmFrequency : null,
      userId: Number(item?.userId),
      managerId: +item?.managerId,
      companyId: item?.companyId,
      categoryId,
      dwmYear: +item?.dwmYear,
      fiscalYear: item?.fiscalYear,
      dwmMonth: this.dwmGenericServiceService.getCurrentMonthByDate(this.selectedFilters.selectedDate),
      dwmDate: this.selectedFilters?.selectedDate ? this.dwmGenericServiceService.formatDate(this.selectedFilters?.selectedDate) : null,
      timeFrom: item?.timeFrom || '',
      timeTo: item?.timeTo || '',
      actionable: item?.actionable || null,
      isRepetativeTask: item?.isRepetativeTask,
      isCriticalTask: item?.isCriticalTask ?? false,
      dwmStatus: item?.dwmStatus || null,
      managerComments: item?.managerComments || null,
      empComments: item?.empComments || null,
      dwmDoc: item?.attachments?.join(',') || null
    };
    // })
    // .filter((item: any): item is any => item !== null);
  }

  /* ------------------------- Verify if required fields are filled ------------------------- */
  // verifyNewTask(items: any) {
  //   let hasError = false;
  //   let payload: any = [];
  //   if (!items?.length) return;

  //   for (const item of items) {
  //     const result = this.saveNewTaskPayload(item);
  //     if (!result && !hasError) {
  //       hasError = true;
  //     }
  //     payload.push(result);
  //   }
  //   if (hasError) {
  //     if (!this.toastr.toasts.some((t: any) => t.toastType === 'error')) {
  //       this.toastr.error('Please fill the mandatory fields');
  //     }
  //     return [];
  //   }

  //   // API CALL
  //   return payload;
  // }

  /* ------------------------- Api Calls ------------------------- */

  onAddNewOrUpdateNonRndTasksApi(items: any, paginatedData?: any, index?: any) {
    const payload: any = this.verifyAndReturnPayload(items);
    if (!payload?.length) return;

    this.httpService.callPostService(this.config.saveOrUpdateMaster, payload).subscribe({
      next: (data: any) => {
        if (data.status) {
          this.toastr.success(data.message);
          if (!items[0].isNew) {
            this.generateData();
          } else if (items[0].isNew) {
            paginatedData.splice(index, 1);
            this.dwmUserTaskList = paginatedData;
            this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);

            // data.data.map((item: any) => {
            //   Object.entries(item).forEach(([key, value]) => {
            //     items[0][key] = value;
            //     console.log(key, value);
            //   });
            // });
          }
        }
      }
    });
  }

  saveOrUpdateRNDTask(items: any, paginatedData?: any, index?: any): void {
    const payload = this.verifyAndReturnPayload(items);
    if (!payload.length) return;

    // console.log(items);
    // console.log('saveOrUpdateeRNDTask - - - - ', payload);

    this.httpService.callPostService(this.config.saveRNDEmployee, payload).subscribe({
      next: () => {
        this.toastr.success('Saved Successfully');
        if (!items[0].isNew) {
          this.generateData();
        } else if (items[0].isNew) {
          paginatedData.splice(index, 1);
          this.dwmUserTaskList = paginatedData;
          this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
        }
      },
      error: (err: any) => {
        this.toastr.warning(err?.error?.message || 'Save failed', 'Warning');
      }
    });
  }

  /* ------------------------- End Api Call ------------------------- */

  
}
